import { canShopInAram } from '../../domain/map/aramRules.js';

/**
 * createShopGateController — Gates shop open by mapId (AR-08).
 * Presentation wiring; allow/deny via domain map rules.
 */
const SHOP_RULE_BY_MAP = {
  aram_proving_grounds: (entity) => canShopInAram(entity)
};

export function createShopGateController({ getMapId }) {
  function canShop(entity) {
    const mapId = typeof getMapId === 'function' ? getMapId() : null;
    const rule = SHOP_RULE_BY_MAP[mapId];
    if (rule) return rule(entity);
    return true;
  }

  function tryOpenShop(entity) {
    if (!canShop(entity)) {
      return { ok: false, reason: 'SHOP_LOCKED_IN_ARAM' };
    }
    return { ok: true };
  }

  return { canShop, tryOpenShop };
}
